import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
} from "@material-ui/core";
import { useQuery, useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";

import { Select } from "../../components/Form";
import LoadingModal from "../../components/LoadingModal";
import { useAlert } from "../../components/Alert";

const GET_USERS = gql`
  query users(
    $latest: Boolean
    $identity: Identity
    $pageSize: Int
    $page: Int
  ) {
    users(
      latest: $latest
      identity: $identity
      pageSize: $pageSize
      page: $page
    ) {
      contents {
        id
        fullName
      }
    }
  }
`;

const UPDATE_CUSTOMERSTATUS = gql`
  mutation updateCustomerStatus($ids: [Int!]!, $status: CustomerStatus!) {
    updateCustomerStatus(ids: $ids, status: $status)
  }
`;

const CHANGESALESPERSON = gql`
  mutation changeSalesperson($ids: [Int!]!, $salespersonId: Int!) {
    changeSalesperson(ids: $ids, salespersonId: $salespersonId)
  }
`;

export default function TransferDialog({
  data,
  changeCustomer,
  open,
  onClose = () => {},
  id,
}) {
  const Alert = useAlert();
  const [newData, setNewData] = useState({
    transferCustomerArray: [
      { label: "待領客戶", value: "WAITING_TO_CONTACT" },
      { label: "無緣客戶", value: "MISS" },
    ],
    transferSalespersonArray: [],
    transferObject: {},
    rangeArray: [
      { label: "A", value: "A" },
      { label: "B", value: "B" },
      { label: "C", value: "C" },
      { label: "D", value: "D" },
      { label: "E", value: "E" },
    ],
    rangeObject: { label: "A", value: "A" },
    attributesArray: [
      { label: "法拍", value: "法拍" },
      { label: "加盟", value: "加盟" },
    ],
    attributesObject: { label: "法拍", value: "法拍" },
    radioValue: "customer",
  });

  function changeDataListener(key, v) {}
  function changeData(key, v, rerender = false) {
    if (rerender) setNewData((prev) => ({ ...prev, [key]: v }));
    else setNewData((prev) => Object.assign(prev, { [key]: v }));
    if (typeof changeDataListener === "function") changeDataListener(key, v);
  }
  const { loading: usersLoading } = useQuery(GET_USERS, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    variables: {
      latest: true,
      identity: "STAFF",
      pageSize: 999,
      page: 1,
    },
    onCompleted({ users }) {
      if (users) {
        let newArray = [{ label: "全部", value: null }];
        users.contents.map((item) => {
          newArray.push({ label: item.fullName, value: item.id });
        });
        changeData("transferSalespersonArray", newArray, true);
      }
    },
    onError(error) {
      return Alert.notice(`${error}`);
    },
  });
  const [updateCustomerStatus, { loading: updateCustomerStatusLoading }] =
    useMutation(UPDATE_CUSTOMERSTATUS, {
      onCompleted({ updateCustomerStatus }) {
        if (updateCustomerStatus) {
          Alert.notice("更改成功！");
          return onClose("refetch");
        } else return Alert.notice("更改失敗！");
      },
      onError(error) {
        return Alert.notice(`${error}`);
      },
    });
  const [changeSalesperson, { loading: changeSalespersonLoading }] =
    useMutation(CHANGESALESPERSON, {
      onCompleted({ changeSalesperson }) {
        if (changeSalesperson) {
          Alert.notice("更改成功！");
          return onClose("refetch");
        } else return Alert.notice("更改失敗！");
      },
      onError(error) {
        return Alert.notice(`${error}`);
      },
    });

  function save() {
    if (newData.radioValue === "customer") {
      updateCustomerStatus({
        variables: { ids: id, status: newData.transferObject.value },
      });
    } else {
      changeSalesperson({
        variables: { ids: id, salespersonId: newData.transferObject.value },
      });
    }
  }
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth={changeCustomer ? "sm" : "xs"}
    >
      <LoadingModal
        loading={
          usersLoading ||
          updateCustomerStatusLoading ||
          changeSalespersonLoading
        }
      />
      {!changeCustomer ? (
        <>
          <DialogContent style={{ display: "flex", justifyContent: "center" }}>
            <FormControl component="fieldset">
              <RadioGroup
                aria-label="gender"
                name="gender1"
                value={newData.radioValue}
                onChange={(v) => {
                  changeData("transferObject", {});
                  changeData("radioValue", v.target.value, true);
                }}
              >
                <Grid container spacing={1}>
                  <Grid item>
                    <FormControlLabel
                      label="客戶系統專區"
                      control={<Radio />}
                      value="customer"
                    />
                  </Grid>
                  <Grid item>
                    <FormControlLabel
                      label="人事員工專區"
                      control={<Radio />}
                      value="salesperson"
                    />
                  </Grid>
                </Grid>
              </RadioGroup>
            </FormControl>
          </DialogContent>
          <DialogContent>
            <Grid container spacing={1} direction={"column"}>
              <Grid item>
                <Typography>轉移至</Typography>
              </Grid>
              <Grid item>
                <Select
                  items={
                    newData.radioValue === "customer"
                      ? newData.transferCustomerArray
                      : newData.transferSalespersonArray
                  }
                  value={newData.transferObject}
                  onChange={(e, v) => {
                    changeData("transferObject", v, true);
                  }}
                />
              </Grid>
            </Grid>
          </DialogContent>
        </>
      ) : (
        <DialogContent dividers>
          <Grid container spacing={1} direction={"row"}>
            <Grid item sm={4}>
              <Typography color="primary">分店</Typography>
              <Typography>總店</Typography>
            </Grid>
            <Grid item sm={4}>
              <Typography color="primary">姓名</Typography>
              <Typography>{data?.name}</Typography>
            </Grid>
            <Grid item sm={4}>
              <Typography color="primary">人員</Typography>
              <Typography>{data?.name}</Typography>
            </Grid>
            <Grid item sm={6}>
              <Typography color="primary">等級</Typography>
              <Select
                items={newData.rangeArray}
                value={newData.rangeObject}
                onChange={(e, v) => {
                  changeData("rangeObject", v, true);
                }}
              />
            </Grid>
            <Grid item sm={6}>
              <Typography color="primary">屬性</Typography>
              <Select
                items={newData.attributesArray}
                value={newData.attributesObject}
                onChange={(e, v) => {
                  changeData("attributesObject", v, true);
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
      )}
      <DialogActions>
        {!changeCustomer ? (
          <Grid container justify="center">
            <Button color="primary" variant="contained" onClick={save}>
              送出
            </Button>
          </Grid>
        ) : (
          <Grid container spacing={1} justify="center">
            <Grid item>
              <Button color="primary" variant="contained" onClick={save}>
                送出
              </Button>
            </Grid>
            <Grid item>
              <Button color="primary" variant="outlined" onClick={onClose}>
                返回
              </Button>
            </Grid>
          </Grid>
        )}
      </DialogActions>
    </Dialog>
  );
}
